module.exports = __webpack_public_path__ + "img/yzlogo.5745cc7d.png";